import type { I18nContextType } from '../../../../i18n';
import type { AddLinesToCountingListResponse } from '../../../../types/countingListCreation';

/**
 * Melding for «Legg til linjer» når backend la inn noen linjer og avviste andre
 * (delvis innlegging). Lister hver avvist vare@lokasjon med årsaken backend oppga.
 */
export const formatAddLinesRejected = (
  result: AddLinesToCountingListResponse,
  t: I18nContextType['t']
): string => {
  const header = t(
    'manager.modules.inventoryCountingDashboard.errors.addLinesPartial',
    { '0': result.linesAdded, '1': result.rejected.length },
    '{0} lagt til, {1} avvist:'
  );
  const rows = result.rejected.map((r) => `• ${r.itemNo} @ ${r.binCode}: ${r.reason}`);
  return [header, ...rows].join('\n');
};
